var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"big",attrs:{"src":""},on:{"click":function($event){return _vm.changeImg($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }